<template>
  <div class="flex-column">
    <sticky :className="'sub-navbar'">
      <div class="filter-container">
        <base-search :searchList="$jczlPzfbSearch" :listQuery='listQuery' v-on:search='handleFilter' v-on:btn-event="onBtnClicked" style="display: inline-block;"  :dynamic='true'></base-search>
      </div>
    </sticky>
    <div class="app-container flex-item">
      <el-row style="height: 100%;" :gutter="8" >
        <el-col :span="4" style="height: 100%;">
          <el-card shadow="never" class="body-small" style="height: 100%;overflow:auto;">
            <basic-tree :Treedata="orgsTree" :isShowCheck="true" @handleNodeClick="handleNodeClick" @getCheckedKeys="getCheckedKeys"></basic-tree >
          </el-card>
        </el-col>
        <el-col :span="20" class="zzb" style="height: 100%;" id="table_box_height">
          <div class="bg-white" style="height: 100%;flex-item">
            <basic-table :tableHeight="tableHeight" :tableHeaderList="$jczlPzfbTableHeader" :tableData="tableData" :listQuery="listQuery" :hasPagination="false"></basic-table >
          </div>
          <div class="line"></div>
          <div class="bg-white" style="height: 100%;flex-item">
            <basic-table :tableHeight="tableHeight" :tableHeaderList="$jczlPzfbTableHeader" :tableData="tableData2" :listQuery="listQuery" :hasPagination="false"></basic-table >
          </div>
        </el-col>
      </el-row>
    </div>


    <!-- 添加弹窗 -->
    <general-form :FormDialog="FormDialog" :FormList="FormList" :title="addTitle" :FormData="addform"  @cancelDialog="cancelDialog" @confirmDialog="confirmDialog"></general-form>

  </div>

</template>

<script>
  import generalForm from '@/components/generalForm'//通用添加弹窗组件

  import {listToTreeSelect} from '@/utils'
  import * as login from '@/api/login'
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'
  import waves from '@/directive/waves' // 水波纹指令
  import Sticky from '@/components/Sticky'
  import elDragDialog from '@/directive/el-dragDialog'
  export default {
    name: 'hdybqygl',
    components: {
      Sticky,
      generalForm
    },
    directives: {
      waves,
      elDragDialog
    },
    data() {
      return {
        listQuery: { // 查询条件
          page: 1,
          limit: 50,
          queryType: '0',
          cxnr:'0',
          key: undefined
        },
        orgs: [], // 用户可访问到的组织列表
        orgsTree: [], // 用户可访问到的所有机构组成的树
        tableData:[],//表格1数据
        tableData2:[],//表格2数据
        tableHeight:500,//表格高度
        CheckedKey:[],//选中数据的id集合
        tableChooseRow:{},//table选中数据
        FormDialog:false,//添加弹窗
        addform:{
          belongArea:'',
          areaName:'',
          areaAddress:'',
          areaNum:'',
          equipment:'false'
        },
        FormList:{//表格列
          column:[
            {columnKey:'belongArea',columnDescription:'归属区域',columnType:'text',prop:'belongArea',width:'120',placeholder:"归属区域",},
            {columnKey:'areaName',columnDescription:'区域名称',columnType:'text',prop:'areaName',width:'120',placeholder:"区域名称",},
            {columnKey:'areaAddress',columnDescription:'区域地址',columnType:'text',prop:'areaAddress',width:'120',placeholder:"区域地址",},
            {columnKey:'areaNum',columnDescription:'区域负责人编号',columnType:'text',prop:'areaNum',width:'120',placeholder:"区域负责人编号",},
            {
              columnKey:'equipment',
              columnDescription:'挂载设备',
              columnType:'select',
              placeholder:"请选择挂载设备",
              prop:'equipment',
              width:'120',
              seleceOption:[
                {label:'否',value:'0'},
                {label:'是',value:'1'},
              ],
              typeId:'Hyb_HaveDevice',//从全局数据字典里获取下拉数据
            },
          ],
          //校验
          rule:{
            belongArea: [{ required: true, message: "归属区域不能为空", trigger: "blur" }, ],
          }
        },
        addTitle:'添加',//添加弹窗标题
      }
    },
    watch: {
      
    },
    computed: {
      
    },
    filters: {
      
    },
    created() {
      
    },
    mounted() {
      this.getOrgTree()
      // 计算table高度
      this.$nextTick(()=>{
      let ele=document.getElementById("table_box_height");
      this.tableHeight=(ele.offsetHeight-50)/2
      window.addEventListener('resize', () => { 
        let ele=document.getElementById("table_box_height");
        this.tableHeight=(ele.offsetHeight-50)/2
        this.$forceUpdate()
      });
      // 计算table高度
    })
    },
    activated() {
      this.getList()
    },
    methods: {
      // 节点点击
      handleNodeClick(data) {
        console.log(data)
      },
      // 添加节点选中数据
      getCheckedKeys(data){
        console.log(data)
        this.CheckedKey = data
        var s = this.CheckedKey.length
        this.tableData = this.$store.state.tableDataSearch.slice(0,s)
      },
      // 按钮点击
      onBtnClicked: function(domId) {
        console.log('you click:' + domId)
        switch (domId) {
          case 'btnDel'://删除
            this.handleDelete(this.tableChooseRow)
            break
          case 'btnAdd'://添加
            this.FormDialog = true
            break
          default:
            break
        }
      },
      // 获取数据
      getList() {
        // login.getSubOrgs(this.listQuery).then(response => {
        //   if(response.code == '200'){
        //     this.tableData = Object.assign([], response.data)
        //   }else{
        //     this.$message({
        //       message:response.message,
        //       type:'warning'
        //     })
        //     this.tableData = []
        //   }
        // }).catch(()=>{
        //   this.tableData = []
        // })
        this.tableData = this.$store.state.tableDataSearch
        this.tableData2 = this.tableData.concat(this.tableData)
      },
      // 获取树形组件数据
      getOrgTree() {
        var _this = this // 记录vuecomponent
        login.getOrgs().then(response => {
          _this.orgs = response.result.map(function(item) {
            return {
              id: item.id,
              label: item.name,
              parentId: item.parentId || null
            }
          })
          var orgstmp = JSON.parse(JSON.stringify(_this.orgs))
          _this.orgsTree = listToTreeSelect(orgstmp)
        })
      },
      // 搜索
      handleFilter() {
        this.listQuery.page = 1
        this.getList()
      },
      // 切换分页
      handleCurrentChange(val) {
        this.tableChooseRow = {}//重置选中项
        this.listQuery.page = val.page
        this.listQuery.limit = val.limit
        this.getList()
      },
      // 行点击
      tableRowClick(row){
        this.tableChooseRow = row
      },
      handleDelete(row) { // 多行删除
        this.tableData.splice(this.tableData.findIndex(e=>e.serialNumber === row.serialNumber),1)
      },
      // add弹窗取消
      cancelDialog(val){
        this.FormDialog = val
      },
      // add弹窗提交
      confirmDialog(){
        this.$store.state.tableDataSearch.push(this.addform)
        this.addform={
          name:'',
          type:'plbz',
          uploadFilsName:'',//上传文件名
        }
        this.FormDialog = false
      },
    },
  }

</script>

<style lang="scss" scoped>
  .zzb{
    display: flex;
    flex-direction: column;
  }
  .line{
    height: 20px;
    width: 100%;
    background: #ccc;
  }
</style>
